"use client"

import { useEffect } from "react"
import * as Sentry from "@sentry/nextjs"

import { useAppAuthState } from "@/hooks/auth/use-app-auth-state"

export function SentryUserIdentifier() {
  const { isSignedIn, currentUser } = useAppAuthState({ includeCurrentUser: true })

  useEffect(() => {
    if (isSignedIn && currentUser) {
      Sentry.setUser({
        id: currentUser.id,
        email: currentUser.email,
        username: currentUser.full_name,
      })
    } else {
      Sentry.setUser(null)
    }
  }, [isSignedIn, currentUser])

  return null
}
